// extracted by mini-css-extract-plugin
export default {"container":"_3pDow","mobile":"_20O04"};